import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { getItem } from "../../api/generics";
import { formatInvoiceNumber, Invoice } from "../../models/invoice";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import InvoiceDetailView from "./InvoiceDetailView";

interface InvoiceDetailModalProps {
  show: boolean;
  invoice?: Invoice;
  onCancel: () => void;
}

const InvoiceDetailModal: React.FC<InvoiceDetailModalProps> = ({
  show,
  invoice,
  onCancel,
}) => {
  const [fullInvoice, setFullInvoice] = useState<Invoice | undefined>(
    undefined,
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show || !invoice?.id) {
      setFullInvoice(undefined);
      return;
    }
    const fetch = async () => {
      setLoading(true);
      const result = await getItem<Invoice>(`/invoices/${invoice.id}/`);
      if (result.status === SUCCESS && result.data) {
        setFullInvoice(result.data);
      } else {
        errorAlert("No se pudo cargar el detalle de la factura.");
        onCancel();
      }
      setLoading(false);
    };
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, invoice?.id]);

  const title =
    invoice?.invoiceNumber
      ? `Factura ${formatInvoiceNumber(invoice)}`
      : "Detalle de Factura";

  return (
    <CModal show={show} onClose={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{title}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        ) : (
          fullInvoice && <InvoiceDetailView invoice={fullInvoice} />
        )}
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onCancel}>
          Cerrar
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default InvoiceDetailModal;
